module.exports = __webpack_public_path__ + "img/555555_C8C8C8_8B8B8B_A4A4A4-256px.9beedf82.png";